import React, { FC } from 'react'

import { AutoStoryArticle, AutoStoryWrapper } from 'modules/Feed/components'

import { useStory } from 'modules/Feed/serviceHooks'
import { getCoverImagePath } from 'shared/utils/getCoverImagePath'

import { AutoStoryProps } from './AutoStory.props'

import '../Story/Story.scss'

const AutoStory: FC<AutoStoryProps> = (props) => {
  const { storyRef, isCollapsed, handleToggleCollapsed, toggleBigCard, isBigCard, setTouched } = useStory({
    story: props.story
  })

  return (
    <AutoStoryWrapper storyRef={storyRef} type={props.story.argument_type} isExpanded={!isCollapsed} {...props}>
      <AutoStoryArticle
        isCollapsed={isCollapsed}
        toggleCollapsed={handleToggleCollapsed}
        toggleBigCard={toggleBigCard}
        article={props?.story?.body || ''}
        storyProperties={props.story.properties}
        title={props?.story?.product?.name}
        productLogo={getCoverImagePath(props.story.product_id)}
        type={props.story.argument_type}
        setTouched={setTouched}
        isBigCard={isBigCard}
      />
    </AutoStoryWrapper>
  )
}

export default AutoStory
